"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var KeytipContent_base_1 = require("./KeytipContent.base");
var Keytip_styles_1 = require("./Keytip.styles");
exports.KeytipContent = Utilities_1.styled(KeytipContent_base_1.KeytipContentBase, Keytip_styles_1.getStyles, undefined, {
    scope: 'KeytipContent'
});
//# sourceMappingURL=KeytipContent.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/Keytip/KeytipContent.js
// module id = 1091
// module chunks = 0